<tab-bar [tabs]="tabs" [(currentTabId)]="currentTabId"></tab-bar>
@if (currentTabId === 'internal-sftp-mgmt') {
  <rn-internal-sftp-mgmt [client]="client"></rn-internal-sftp-mgmt>
}
@if (currentTabId === 'external-sftp-mgmt') {
  <rn-external-sftp-mgmt></rn-external-sftp-mgmt>
}
@if (currentTabId === 'key-config') {
  <app-key-config></app-key-config>
}
